import type { ItemId } from './inventory';

// UNLOCK STATE (research gate). Recipes flagged `locked: true` in ui/crafting.ts (guns, explosives,
// reinforced tier) start unavailable until researched at a research_table: consume one of the item
// (rolled by RNG or found) + its RESEARCH.costs[id] salvage, then it is unlocked for good. Persisted in
// localStorage so it survives a reload -- there is no server yet (see LocalBackend), so this is the
// authority the same way devMode/#test are client-side today.
const KEY = 'oxide.unlocked';

let unlocked = new Set<ItemId>(load());

function load(): ItemId[] {
  try { const raw = localStorage.getItem(KEY); return raw ? (JSON.parse(raw) as ItemId[]) : []; }
  catch { return []; }
}
function persist(): void {
  try { localStorage.setItem(KEY, JSON.stringify([...unlocked])); } catch { /* storage full/blocked */ }
}

export function isUnlocked(id: ItemId): boolean {
  return unlocked.has(id);
}

export function unlock(id: ItemId): void {
  if (unlocked.has(id)) return;
  unlocked.add(id);
  persist();
}

// #test loadout: unlock everything for THIS SESSION ONLY. Deliberately NOT persisted: a #test run
// used to write the full set into localStorage, so every normal world after it started with the
// research table fully cleared (the owner hit exactly this).
export function unlockAll(ids: Iterable<ItemId>): void {
  for (const id of ids) unlocked.add(id);
}

// Dev/debug reset (not currently wired to a button; here for parity with resetToDefaults()).
export function clearUnlocks(): void {
  unlocked = new Set();
  persist();
}
